export * from './ArticlePicture';
